if (!customElements.get("util-accordion")) {
  class UtilAccordion extends HTMLElement {
    constructor() {
      super();

      this.expandMultiple = this.dataset.expandMultiple == "true";
      this.expandMultipleSections = this.dataset.expandMultipleSections == "true";
      this.sectionsSelector = this.dataset.sectionsSelector;
      this.accordions = this.querySelectorAll(".accordion");

      this.accordions.forEach((accordionItem) => {
        const button = accordionItem.querySelector("button[aria-expanded]");
        const panel = accordionItem.querySelector('[role="region"]');

        // Reset panel height to 0 initially
        panel.style.height = "0px";
        panel.style.overflow = "hidden";
        panel.style.transition = "height 0.3s ease";

        button.addEventListener("click", () => {
          const expanded = button.getAttribute("aria-expanded") === "true";

          expanded ? this.collapse(button, panel, accordionItem)
                   : this.expand(button, panel, accordionItem);
        });
      });
    }

    expand(button, panel, accordionItem) {
      button.setAttribute("aria-expanded", "true");
      accordionItem.classList.add("open");
      accordionItem.classList.add("scheme-2");

      panel.style.height = panel.scrollHeight + "px";

      if (!this.expandMultiple) {
        this.querySelectorAll('button[aria-expanded="true"]').forEach((btn) => {
          if (btn !== button) {
            const acc = btn.closest(".accordion");
            const pnl = acc.querySelector('[role="region"]');
            this.collapse(btn, pnl, acc);
          }
        });
      }
    }

    collapse(button, panel, accordionItem) {
      button.setAttribute("aria-expanded", "false");
      accordionItem.classList.remove("open");
      accordionItem.classList.remove("scheme-2");

      panel.style.height = "0px";
    }
  }

  customElements.define("util-accordion", UtilAccordion);
}
